<script>
export default {
  name: "QrCodeDisplay"
}
</script>

<template>
  <div class="qr-code-display">
    <div class="code-content">
      <img class="qr-code-img" src="@/assets/f-icon/qr-code-3.png">
      <div class="q-c-title">喜来健化妆品官网</div>
      <div class="q-c-label">扫码了解更多</div>
    </div>
    <div class="code-content">
      <img class="qr-code-img" src="@/assets/f-icon/qr-code-2.png">
      <div class="q-c-title">美缔可化妆品抖音号</div>
      <div class="q-c-label">扫码了解更多</div>
    </div>
    <div class="code-content">
      <img class="qr-code-img" src="@/assets/f-icon/qr-code-1.jpg">
      <div class="q-c-title">喜来健化妆品官方公众号</div>
      <div class="q-c-label">扫码了解更多</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.qr-code-display {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  flex-wrap: nowrap;

  .code-content {
    font-size: 12px;

    .qr-code-img {
      width: 86px;
      height: 86px;
    }

    .q-c-title {
      color: #FFFFFF;
      margin: 1em 0 0.5em;
    }
  }
}
</style>
